import request from '@/utils/request'

// 获取用户列表（分页）
export function getUserPage(params) {
  return request({
    url: 'api/enuser/list',
    method: 'get',
		params
  })
}

export function get(id) {
  return request({
    url: 'api/enuser/' + id,
    method: 'get'
  })
}

export function edit(data) {
  return request({
    url: 'api/enuser',
    method: 'PUT',
    data
  })
}

export function add(data) {
  return request({
    url: 'api/enuser',
    method: 'POST',
    data
  })
}

export function editStatus(data) {
  return request({
    url: 'api/enuser/status',
    method: 'put',
    data
  })
}

export function del(ids) {
  return request({
    url: 'api/enuser',
    method: 'delete',
    data: ids
  })
}

//获取当前登录用户权限树
export function getMenus(params) {
  return request({
    url: '/api/enuser/menus/tree',
    method: 'get',
    params
  })
}

// 获取企业的用户详情(包括数据权限和菜单功能权限)
export function getDetail(userId) {
  return request({
    url: 'api/enuser/' + userId,
    method: 'get'
  })
}

export function getEntUserList(params) {
  return request({
    url: 'api/enuser/list',
    method: 'get',
    params
  })
}

// 已删除用户列表
export function getDeletedUserList(params) {
  return request({
    url: 'api/enuser/deleted/list',
    method: 'get',
    params
  })
}


export default { getUserPage, get, edit, add, del, getDetail, getMenus, editStatus, getEntUserList, getDeletedUserList }

